















import Vue from "vue";
import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";
import { v4 as uuidv4 } from "uuid";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwInputText: iwInputText,
    },
    data: function() {
        return {
            specificId: uuidv4() as string
        };
    },
    computed: {
        ...mapState("UserModule", ["user"]),
    },
});
